var context = require('./tools/context');
var frames = require('./streams/frames');
var audio_stream = require('./streams/audio_stream');

// 

var playing   = false;
var sample    = null;
var sampleBuffer = null;
window.songStart = 0;
var songDuration = 0;
var pausedAt  = 0;

var finished_cb = function(){};

// dev
var gain = context.createGain();
gain.connect(context.destination);
gain.gain.value = 1;

function load(cb) {
  getSong( function(buffer) {
    sampleBuffer = buffer;
    songDuration = buffer.duration;
    cb();
  });
}

function finished(cb) {
  finished_cb = cb;
}

function pause() {
  if(playing) {
    // put it slightly in the future for the sake of accuracy
    pausedAt = context.currentTime + 0.01;
    sample.stop(pausedAt);
    playing = false;
    audio_stream.pause();
  }
}

function play() {
  if(!playing) {
    // how far were we through the song?
    var progress = pausedAt - songStart;
    // if the song picked up now, what would its
    // virtual start point have been? the stream needs
    // this value.
    window.songStart = context.currentTime - progress;

    sample = context.createBufferSource();
    sample.buffer = sampleBuffer;
    sample.connect(gain);
    // start the sample now at our progress point
    sample.start(context.currentTime, progress);
    sample.onended = end_callback;

    playing = true;
    audio_stream.offset(window.songStart);
    audio_stream.play();
  }
}

function end_callback() {
  // the sample stopped, but we might have just paused.
  if (playing) {
    playing = false;
    finished_cb();
  }
}

// 

function getSong(callback) {
  var request = new XMLHttpRequest();
  request.open("GET", '/audio/rugs.mp3', true);
  request.responseType = "arraybuffer";

  request.onload = function() {
    context.decodeAudioData(request.response, callback);
  };

  request.send();
}

var structure_stream = frames.map(function() {
  return playing ? context.currentTime - window.songStart : 0;
});

var progress_stream = frames.map(function() {
  return playing ?
    (context.currentTime - window.songStart) / songDuration :
    (pausedAt - window.songStart) / songDuration
  ;
})

module.exports = {
	load: load,
	play: play,
	pause: pause,
  finished: finished,
  structure_stream: structure_stream,
  progress_stream: progress_stream
};

window.play = play;
window.pause = pause;